import { TreeNode } from "@/types/tree";
import {
  getTreeNodePositionAndSize,
  getElementComputedStyleFromNode
} from "@/lib/canvas/helpers";
import { documentStore } from "@/store/store";
import { getNodeParent } from "../tree/tree";
import { parseFloatAndFixTo2Digits } from "@/util/math";

export function getOnCanvasColumnWidthInPercent(column: TreeNode) {
  const columnWidthInPx = getOnCanvasColumnWidthInPixels(column);
  const columnParentWidthInPx = getOnCanvasColumnParentWidthInPixels(column);

  if (!columnWidthInPx || !columnParentWidthInPx) return false;

  const columnWidthInPercent = parseFloatAndFixTo2Digits(
    (columnWidthInPx / columnParentWidthInPx) * 100
  );

  return columnWidthInPercent ? columnWidthInPercent : false;
}

export function calcNewPercentWidthForColumn(
  column: TreeNode,
  pixelsToAdd: number,
  currentWidthInPx: number
) {
  const columnWidthPx = currentWidthInPx;
  const columnParentWidthPx = getOnCanvasColumnParentWidthInPixels(column);

  if (!columnWidthPx || !columnParentWidthPx) return false;

  const newColumnWidthInPercent =
    100 * ((columnWidthPx + pixelsToAdd) / columnParentWidthPx);

  return parseFloatAndFixTo2Digits(newColumnWidthInPercent);
}

export function getOnCanvasColumnWidthInPixels(column: TreeNode) {
  const columnPosition = getTreeNodePositionAndSize(column);
  if (columnPosition) {
    return columnPosition.width;
  }

  return false;
}

function getOnCanvasColumnParentWidthInPixels(column: TreeNode) {
  const columnParent = getNodeParent(documentStore.document.tree, column.id);

  if (columnParent) {
    const columnParentPosition = getTreeNodePositionAndSize(columnParent);
    if (columnParentPosition) {
      return columnParentPosition.width;
    }
  }

  return false;
}

export function getOnCanvasColumnMinWidthBasedOnPadding(column: TreeNode) {
  const computedStyle = getElementComputedStyleFromNode(column);
  if (!computedStyle) return false;

  const paddingLeft = parseInt(computedStyle.getPropertyValue("padding-left"));
  const paddingRight = parseInt(
    computedStyle.getPropertyValue("padding-right")
  );

  if (Number.isNaN(paddingLeft) || Number.isNaN(paddingRight)) return false;

  const columnParentWidthPx = getOnCanvasColumnParentWidthInPixels(column);

  if (!columnParentWidthPx) return false;

  const minColumnWidthInPercent =
    100 * ((paddingLeft + paddingRight) / columnParentWidthPx);

  return Math.ceil(minColumnWidthInPercent);
}
